<template lang="pug">
.label
  label.smx-label(
    :class="{ 'md:text-right': true, required: props.required }",
    :style="{ 'min-width': props.minWidth }"
  ) {{ props.label }}
  SmxInfo(
    v-if="props.description",
    :title="props.label || ''",
    :content="props.description"
  )
div(class="max-md:mb-3", :aria-label="props.label || ''")
  slot
</template>

<script setup lang="ts">
import SmxInfo from "@shared/components/elements/SmxInfo.vue";

const props = defineProps<{
  label?: string;
  description?: string;
  required?: boolean;
  minWidth?: number;
}>();
</script>

<style scoped>
.smx-label {
  word-break: break-all;
}
</style>
